import $ from 'jquery';

const hamburgerEl = '.c-hamburger__button';
const hamburgerItemsEl = '.c-hamburger__item';
const navEl = '.nav';
const navBackgroundEl = '.nav__background';
const navContainerEl = '.nav__container';
const navWrapperEl = '.navm__wrapper';
const jsNavPrevEl = '.js-nav-prev';
const jsNavNextEl = '.js-nav-next';
const navPageEl = '.navm__page';
const headerEl = '.header';
const menuHeaderEl = '.navm__header';
const bookNowEl = '.book-now';

/**
 * Toggle navigation
 * @param show
 * @returns {boolean}
 */
function toggleNav(show) {
  if (show === true) {
    $(navEl).addClass('open');
    $('body').addClass('freeze menu-open');
    setTimeout(() => {
      $(navBackgroundEl).addClass('open');
    }, 0);

    setTimeout(() => {
      $(bookNowEl).addClass('nav-opaque');
    }, 250);

    setTimeout(() => {
      $(navContainerEl).addClass('open');
    }, 250);

    return false;
  }

  $('body').removeClass('menu-open');
  $(navBackgroundEl).removeClass('open');
  $(navContainerEl).removeClass('open');
  $(bookNowEl).removeClass('nav-opaque');

  setTimeout(() => {
    $(navEl).removeClass('open');
    $('body').removeClass('freeze');
  }, 300);

  return undefined;
}

/**
 * Get menu transform-x value
 * @returns {number}
 */
function getWrapperTransform() {
  let transformX = 0;

  if ($(navWrapperEl).attr('style')) {
    const transformData = $(navWrapperEl).css('transform').split(/[()]/)[1];
    const transformValues = transformData.split(',');
    transformX = parseInt(transformValues[4], 10);
  }

  return transformX;
}

/**
 * Set menu transform-x value
 * @param transform
 */
function setWrapperTransform(transform) {
  $(navWrapperEl).css({ 'transition-duration': '300ms', transform: `translateX(${transform}px)` });
}

/**
 * Toggle navigation page
 * @param next
 * @returns {boolean}|void
 */
function pageNavToggle(next) {
  if (next === true) {
    setWrapperTransform(getWrapperTransform() - $(navPageEl).width());
    return false;
  }

  setWrapperTransform(getWrapperTransform() + $(navPageEl).width());
  return undefined;
}

/**
 * Toggle sub-navigation
 * @param levelParam
 * @param idParam
 * @return void
 */
function subNavToggle(levelParam, idParam) {
  const level = `.${levelParam}`;
  const id = `#${idParam}`;

  $(level).removeClass('open');
  $(id).addClass('open');
}

/**
 * Reset navigation to default state
 * @return void
 */
function navResetAll() {
  $('.level-2, .level-3').animate({ opacity: 0 }, 200, 'linear', function () {
    $(this).removeAttr('style');
    $(navWrapperEl).removeAttr('style');
  });
}

/**
 * Site header toggle
 * @param show
 * @returns {boolean}
 */
function siteHeaderToggle(show) {
  if (show === true) {
    $(headerEl).show().animate({ opacity: 1 }, 300, 'linear');
    return false;
  }

  $(headerEl).animate({ opacity: 0 }, 300, 'linear', () => {
    $(headerEl).hide();
  });

  return undefined;
}

/**
 * navigation header toggle
 * @param show
 * @returns {boolean}
 */
function navHeaderToggle(show) {
  if (show === true) {
    $(menuHeaderEl).show().animate({ opacity: 1 }, 300, 'linear');
    return false;
  }

  $(menuHeaderEl).animate({ opacity: 0 }, 300, 'linear', () => {
    $(menuHeaderEl).hide();
  });

  return undefined;
}

// Function to remove ARIA attributes on larger screens
function removeAriaAttributesOnLargeScreens() {
  // eslint-disable-next-line no-undef
  if ($(window).width() >= breakpoints.tablet) {
    // Remove ARIA attributes from titles
    $('.destination-menu__title').removeAttr('role');
    $('.destination-menu__title').removeAttr('aria-expanded');
    $('.destination-menu__title').removeAttr('aria-controls');
    $('.destination-menu__title').removeAttr('tabindex');

    // Remove ARIA attributes from region containers
    $('.destination-menu__title').parent('[role="region"]').removeAttr('role');
    $('.destination-menu__title').parent('[role="region"]').removeAttr('aria-label');

    // Remove ARIA attributes from grids
    $('.destination-menu__grid').removeAttr('aria-hidden');
  }
}

$(document).on('click tap', hamburgerEl, () => {
  // eslint-disable-next-line no-undef
  if ($(window).width() >= breakpoints.desktop) {
    return false;
  }

  $(hamburgerEl).toggleClass('open').find(hamburgerItemsEl).toggleClass('open');

  if ($(hamburgerEl).hasClass('open')) {
    toggleNav(true);
    return false;
  }

  toggleNav();
  navResetAll();

  if ($(menuHeaderEl).length) {
    siteHeaderToggle(true);
    navHeaderToggle();
  }

  return false;
});

$(document).on('click tap', jsNavNextEl, (event) => {
  // currentTarget, not target: Chrome auto-translate wraps text in <font> elements
  const itemId = $(event.currentTarget).data('id');
  const jumpTo = $(event.currentTarget).data('jump');

  pageNavToggle(true);
  subNavToggle(jumpTo, itemId);

  if ($(menuHeaderEl).length) {
    siteHeaderToggle();
    navHeaderToggle(true);
  }
});

$(document).on('click tap', jsNavPrevEl, () => {
  pageNavToggle();

  if (getWrapperTransform() + $(navPageEl).width() === 0) {
    siteHeaderToggle(true);
    navHeaderToggle();
  }
});

// Accordion functionality for destination menu titles on mobile
$(document).on('click tap keyup', '.destination-menu__title', (event) => {
  // eslint-disable-next-line no-undef
  if ($(window).width() >= breakpoints.tablet) {
    return;
  }

  // Handle keyboard events
  if (event.type === 'keyup' && event.keyCode !== 13 && event.keyCode !== 32) {
    return; // Only respond to Enter (13) and Space (32)
  }

  event.preventDefault();

  const $title = $(event.currentTarget);
  const gridId = $title.attr('aria-controls');
  const $grid = $(`#${gridId}`);

  // Close other accordions in the same wrapper
  $title.closest('.destination-menu-wrapper')
    .find('.destination-menu__title')
    .not($title)
    .removeClass('open')
    .attr('aria-expanded', 'false');
  $title.closest('.destination-menu-wrapper')
    .find('.destination-menu__grid')
    .not($grid)
    .removeClass('open')
    .attr('aria-hidden', 'true');

  // Toggle current accordion
  $title.toggleClass('open');
  $grid.toggleClass('open');

  // Update ARIA attributes
  const isNowOpen = $title.hasClass('open');
  $title.attr('aria-expanded', isNowOpen.toString());
  $grid.attr('aria-hidden', (!isNowOpen).toString());
});

// Remove ARIA attributes on page load for large screens
$(document).on('ready', () => {
  removeAriaAttributesOnLargeScreens();
});
